export const PrimaryButton = (props) => {
    const {
        children,
        onClick,
        disabled,
        className,
        outlined = false,
        fullWidth = true,
        type = 'button',
    } = props;

    const getButtonClasses = () => {
        if (!outlined) {
            return `bg-primary text-white hover:bg-transparent hover:text-primary`
        } else {
            return `bg-transparent text-primary hover:bg-primary hover:text-white`
        }
    }

    return (
        <button
            onClick={onClick}
            type={type}
            disabled={disabled}
            className={`rounded-md ${fullWidth ? 'w-full' : ''} border border-solid border-primary px-2 py-1 text-sm font-semibold shadow-sm transition-all duration-300 ease-in-out ${getButtonClasses()} ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'} ${className ?? ''}`}
        >
            {children}
        </button>
    )
}